import React, { HTMLAttributeAnchorTarget, ReactNode } from 'react';

import { Link as GatsbyLink } from 'gatsby';
import styled from 'styled-components';

import RawButton from 'components/RawButton/RawButton';

import { isExternalUrl } from 'utils/linkResolver';

const PseudoLink = styled.span`
  cursor: pointer;
`;

interface LinkProps {
  to: string | undefined;
  target?: HTMLAttributeAnchorTarget;
  onClick?: () => void;
  onMouseEnter?: () => void;
  children: ReactNode[] | ReactNode;
  className?: string;
  activeStyle?: object;
}

const Link: React.FC<LinkProps> = ({
  className,
  to,
  target,
  onClick,
  onMouseEnter,
  children,
  activeStyle,
  ...props
}) => {
  if (to) {
    if (isExternalUrl(to)) {
      return (
        <a className={className} href={to} target={target} {...props}>
          {children}
        </a>
      );
    } else {
      return (
        <GatsbyLink
          className={className}
          to={to}
          onClick={onClick}
          onMouseEnter={onMouseEnter}
          target={target}
          activeStyle={activeStyle}
          {...props}
        >
          {children}
        </GatsbyLink>
      );
    }
  } else if (onClick) {
    return (
      <RawButton className={className} onClick={onClick} {...props}>
        {children}
      </RawButton>
    );
  }

  return <PseudoLink className={className}>{children}</PseudoLink>;
};

export default Link;
